import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';

// services
import { ConfigService } from '@campfire-nx/api';

import { ClaimDetailsService } from '@open-portal-app/core/services/claim-details.service';

@Component({
  selector: 'app-claims-list',
  templateUrl: './claims-list.component.html',
  styleUrls: ['./claims-list.component.scss']
})
export class ClaimsListComponent {
  @Input() claims!: any;
  @Input() label!: string;
  configData!: any;

  constructor(
    private configService: ConfigService,
    private router: Router,
    private claimDetailsService: ClaimDetailsService
  ) { }

  ngOnInit() {
    this.configData = this.configService.data;
  }

  getClaimType(productType: string, eventType: string) {
    let claimTypeLabel = '-';
    const claimTypes = this.configData.types.claimTypes[productType];
    const claimEventTypes = this.configData.types.claimEventTypes;

    Object.entries<any>(claimTypes).forEach(([claimKey]) => {
      Object.entries<any>(claimEventTypes[claimKey]).forEach(([eventKey, eventValue]) => {
        let continues = true;

        if (eventType === eventKey) {
          claimTypeLabel = eventValue.label

          continues = false
        }
        return continues;
      })

      return claimTypeLabel === '-';
    });

    return claimTypeLabel
  }

  getClaimStatusLabel(claim: any) {
    const isTpaClaim = !!(claim?.tpa_partner && Object.keys(claim?.tpa_partner).length > 0);
    return this.claimDetailsService.getClaimStatus(isTpaClaim, isTpaClaim ? claim?.tpa_claim_status : claim?.state) as any;
  }

  getClaimStatusVariant(claim: any) {
    const isTpaClaim = !!(claim?.tpa_partner && Object.keys(claim?.tpa_partner).length > 0);
    return this.claimDetailsService.getClaimStatusVariant(isTpaClaim ? claim?.tpa_claim_status : claim?.state) as any;
  }

  getIcon(productType: string){
    switch (productType) {
      case 'C':
        return 'management-damagecar-small';
      case 'H':
        return 'management-damagehouse-small';
      case 'T':
        return 'travel-small';
      default:
        return '';
    }
  }

  goToClaim(claim: any) {
    this.router.navigate([`/policy/${claim.product?.class}/${claim.policy_slug}/claim/${claim.slug}`]);
  }
}

